const TRACK_COLOR_PATHS = ['event', 'template'];

export const shouldRepaintColor = (path: string) =>
  TRACK_COLOR_PATHS.some(option => option === path);
